import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../services/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class HesabimService {
  private passwordUrl = environment.genService +'Gen/GenKullaniciProfileChangePassword';
  constructor(private _httpClient: HttpClient) { }

  changePasswordService(model: any): Observable<any> {
    return this._httpClient.post(this.passwordUrl, model, { responseType: 'text' }).pipe(
      catchError((error) => {
        return throwError(() => new Error(error.message || 'API Hatası'));
      })
    );
  }
}
